// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__1ni31","homeWidgets":"home_homeWidgets__2Ebub"};